import React from 'react';
import { Link} from 'react-router-dom';




const Project = ({ item }) => {
  
  return (
    <div key={item.id} className='flex flex-col items-center text-center'>
      <div className='mb-8'>
        <img className='rounded-2xl w-96 h-60'  src={item.image} alt='' />
      </div>
      <p className='capitalize text-accent text-sm mb-3'>{item.category}</p>
      <h3 className='text-2xl font-semibold capitalize mb-3'>{item.name}</h3>
      
      <a className="btn btn-outline bg-emerald-900 w-full my-1" href={item.link} target="_blank">See Projects</a>
      <Link to={`/services/${item.id}`}  className="btn btn-outline bg-emerald-900 w-full">View Details</Link>
      
    </div>
  );
};

export default Project;
